import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-template-list',
  templateUrl: './no-template-list.component.html',
  styleUrls: ['./no-template-list.component.sass']
})
export class NoTemplateListComponent {

  @Input({required: true}) searchTerm: string|undefined = '';
  @Input() showHeader: boolean = true;

  constructor(private router: Router ) { }

  onClick() {
    this.router.navigate(['main', 'templates', 'create']);
  }
}
